import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { PreciselyAddressWithUnit } from "@covertree/features";
import { SelectOption } from "@covertree/ui";

import { ClaimSummaryBox } from "@routing/routes/ClaimSummary/types";
import { SummaryStepHistory } from "@routing/paths";

export interface PolicyDetailsState {
  dateOfLoss: Date;
  address: SelectOption<PreciselyAddressWithUnit>;
  policyLocator: string;
}

const initialState: PolicyDetailsState = {
  dateOfLoss: undefined,
  address: undefined,
  policyLocator: undefined,
};

const policyDetailsSlice = createSlice({
  name: "policyDetails",
  initialState,
  selectors: {
    selectPropertyAddress: (state) => state.address,
    selectPolicyDetails: (state) => state,
    selectPolicyDetailsSummary: ({
      address,
      dateOfLoss,
      policyLocator,
    }): ClaimSummaryBox => {
      const addressProperties = [
        {
          value: address?.value.formattedAddress,
          label: "Property Address",
          fullWidth: !address?.value.lotUnit,
        },
        {
          value: address?.value.lotUnit,
          label: "Unit / Lot#",
          fullWidth: false,
        },
      ];
      return {
        boxTitle: "Policy Details",
        navigate: SummaryStepHistory.POLICY_DETAILS,
        items: [
          ...(!policyLocator ? addressProperties : []),
          {
            value: dateOfLoss?.toLocaleDateString("en-US"),
            label: "Date of loss",
            fullWidth: false,
          },
        ].filter((el) => el.value),
      };
    },
  },
  reducers: {
    setPropertyAddress: (
      state,
      action: PayloadAction<SelectOption<PreciselyAddressWithUnit>>
    ) => {
      state.address = action.payload;
    },
    setDateOfLoss: (state, action: PayloadAction<Date>) => {
      state.dateOfLoss = action.payload;
    },
    setPolicyLocator: (state, action: PayloadAction<string>) => {
      state.policyLocator = action.payload;
    },
    resetPolicyDetails: () => initialState,
  },
});

export const {
  actions: {
    setPropertyAddress,
    setDateOfLoss,
    setPolicyLocator,
    resetPolicyDetails,
  },
  selectors: {
    selectPropertyAddress,
    selectPolicyDetails,
    selectPolicyDetailsSummary,
  },
} = policyDetailsSlice;
export { initialState as policyDetailsInitialState };
export default policyDetailsSlice;
